import { icons_old } from './icons_old';
import { icons_new } from './icons_new';

export type IconType = keyof typeof icons_old | keyof typeof icons_new;

export const icons = { ...icons_old, ...icons_new };
